import { render, staticRenderFns } from "./PatientClinicalDataForm.vue?vue&type=template&id=147b7c56&scoped=true&"
import script from "./PatientClinicalDataForm.vue?vue&type=script&lang=js&"
export * from "./PatientClinicalDataForm.vue?vue&type=script&lang=js&"
import style0 from "./PatientClinicalDataForm.vue?vue&type=style&index=0&id=147b7c56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147b7c56",
  null
  
)

export default component.exports